/* eslint-disable no-unused-vars */
import { Table } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import AddNewPaymentMethod from "../../../../components/modals/AddNewPaymentMethod";

function Body({ domainBrand, corridor, isLoading, defaultChargeList }) {
  const { Column } = Table;
  const history = useHistory();
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  const tableData =
    defaultChargeList &&
    defaultChargeList?.map((i, idx) => {
      return { ...i, key: idx + 1 };
    });
  
  
  return (
    <React.Fragment>
      <AddNewPaymentMethod
        show={show}
        handleClose={() => setShow(false)}
        dictionary={dictionary}
        corridor={corridor}
      />
      <div className="app-content hor-content">
        <div className="container">
          <div className="page-header">
            <div>
              <h1 className="page-title">
                {dictionary
                  ? dictionary["para_payment_methods_charges"]
                  : "Online Payment Method Fee"}
              </h1>
              {/* <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                {dictionary
                  ? dictionary["WO_FOR_EACH_TRANSACTION_565513693"]
                  : `For each transaction, you can charge a fee determined by the payment method(Card Payment, Bank Transfer, Wallet ).`}
              </li>
            </ol> */}
            </div>
            <div className="ms-auto pageheader-btn">
              <button
                onClick={() => setShow(true)}
                className="btn btn-primary btn-icon text-white me-2"
                type={"button"}
              >
                <span>
                  <i className="fa fa-folder-plus" />
                </span>{" "}
                &nbsp;
                {dictionary
                  ? dictionary["WO_ADD_NEW_PAYMENT_METH_-1228148298"]
                  : "Add New Payment Method Fee"}
              </button>

              <button
                onClick={() => history.push("/fee/fixed-amount-fee")}
                // to="/fee/fixed-amount-fee"
                type={"button"}
                className="btn btn-primary btn-icon text-white me-2"
              >
                <span>
                  <i className="fa fa-folder-plus" />
                </span>{" "}
                &nbsp;
                {dictionary
                  ? dictionary["para_default_rates"]
                  : "Add Fixed Amount Fee"}
              </button>
            </div>
          </div>

          <div className="row row-sm">
            <div className="col-lg-12 col-md-12 mt-4">
              <div className="table-responsive">
                <Table
                  dataSource={tableData}
                  className="w-100 table tbody"
                  loading={isLoading}
                >
                  <Column
                    title="Fee Category"
                    dataIndex="createdDate"
                    key="1"
                    className=""
                    render={(text) => {
                      return (
                        <span className="text-lowercase whitespace">
                          {moment(text).format("DD-MM-YYYY")}
                        </span>
                      );
                    }}
                  />

                  <Column
                    title="Transaction Originating Country"
                    dataIndex="createdDate"
                    key="1"
                    className=""
                    render={(text) => {
                      return (
                        <span className="text-lowercase whitespace">
                          {moment(text).format("DD-MM-YYYY")}
                        </span>
                      );
                    }}
                  />

                  <Column
                    title="Currency"
                    dataIndex="createdDate"
                    key="1"
                    className=""
                    render={(text) => {
                      return (
                        <span className="text-lowercase whitespace">
                          {moment(text).format("DD-MM-YYYY")}
                        </span>
                      );
                    }}
                  />

                  <Column
                    title="Range"
                    dataIndex="createdDate"
                    key="1"
                    className=""
                    render={(text) => {
                      return (
                        <span className="text-lowercase whitespace">
                          {moment(text).format("DD-MM-YYYY")}
                        </span>
                      );
                    }}
                  />

                  <Column
                    title="Modified"
                    dataIndex="createdDate"
                    key="1"
                    className=""
                    render={(text) => {
                      return (
                        <span className="text-lowercase whitespace">
                          {moment(text).format("DD-MM-YYYY")}
                        </span>
                      );
                    }}
                  />

                  <Column
                    title="Rate Type"
                    dataIndex="createdDate"
                    key="1"
                    className=""
                    render={(text) => {
                      return (
                        <span className="text-lowercase whitespace">
                          {moment(text).format("DD-MM-YYYY")}
                        </span>
                      );
                    }}
                  />

                  <Column
                    title="Fee"
                    dataIndex="createdDate"
                    key="1"
                    className=""
                    render={(text) => {
                      return (
                        <span className="text-lowercase whitespace">
                          {moment(text).format("DD-MM-YYYY")}
                        </span>
                      );
                    }}
                  />

                  <Column
                    title="Approved"
                    dataIndex="createdDate"
                    key="1"
                    className=""
                    render={(text) => {
                      return (
                        <span className="text-lowercase whitespace">
                          {moment(text).format("DD-MM-YYYY")}
                        </span>
                      );
                    }}
                  />
                  <Column
                    title="Actions"
                    dataIndex="createdDate"
                    key="1"
                    className=""
                    render={(text) => {
                      return (
                        <span className="text-lowercase whitespace">
                          {moment(text).format("DD-MM-YYYY")}
                        </span>
                      );
                    }}
                  />
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Body;
